import './loader.css';
import React from 'react';
const Loader = _ref => {
  let {
    className = ''
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${className}`
  });
};
export default Loader;
const commonStyles = "c1qd8izy";